module.exports = __webpack_public_path__ + "static/media/item_34_5.af523a4d.png";